import React from 'react'
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link } from 'react-router-dom';
function Program_Popup_Content() {
  return (
    <div>
      {/* ----------------------mobile view--------------------- */}
      {/* <div className='container  d-lg-none d-md-block'>
        <h1 className='display-5 text-dark text-center pt-4'>Our Program</h1>
        <div className='row pt-2'>
            <div className='col-md-6'>
                <div className='mobile_Program_pop_up_text'>
                <h5 className='text-center'>Traineeship Program</h5>
                <p className='text-center'>Immerse in real-world challenges, gaining practical insights and honing your skills for a dynamic career journey.</p>
                <div className='container pt-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className=''>
                      <ul className=''>
                      <Link to='ML' className='program_popup_link'><li className='k'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Machine Learning</li></Link>
                      <Link to='/CS' className='program_popup_link'><li className='py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Cyber Security</li></Link>
                      </ul>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <ul>
                      <Link to='/WD' className='program_popup_link'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Web Development </li></Link>
                      <Link to='/CC' className='program_popup_link'><li className=' py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Cloud Computing</li></Link>
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <div className='text-center'>
                <Link to='/Traineeship-program'><button  className="text-white shadow-sm fs-6 px-5 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
            <div className='col-md-6 border-top'>
                <div className='mobile_Program_pop_up_text pt-3'>
                <h5 className='text-center'>Advance Program</h5>
                <p className='text-center'>Unleash your potential through our comprehensive programs, designed to propel your expertise to new heights </p>
                <div className='container pt-3'>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className=''>
                      <ul className=''>
                      <Link to='/CCD' className='program_popup_link'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />DSA with C, C++</li></Link>
                      <Link to='/MS' className='program_popup_link'><li className='py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Mern Stack</li></Link>
                      </ul>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <ul>
                      <Link to='/PY' className='program_popup_link'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Python </li></Link>
                      <Link to='/java' className='program_popup_link'><li className='py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Java</li></Link>
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <div className='text-center'>
                <Link to='/Advance_program'><button  className="text-white shadow-sm fs-6 px-5 pt-1 pb-2 Navbar_button">View More</button></Link>
                </div>
            </div>
        </div>
      </div> */}

      {/* ----------------------desktop view--------------------- */}
      <div className='container pb-4 d-none d-lg-block'>
        <h1 className='display-5 text-dark text-center'>Our Program</h1>
        <div className='row pt-4'>
            <div className='col-md-6'>
                <div className='Program_pop_up_text'>
                <h5 className='text-center'>Traineeship Program</h5>
                <p className='px-5 pt-2 text-center'>Immerse in real-world challenges, gaining practical insights and honing your skills for a dynamic career journey.</p>
                <div className='container'>
                  <div className='row'>
                  <div className='col-md-6'>
                      <div className=''>
                      <ul className=''>
                      <Link to='/ML' className='program_popup_link d-flex justify-content-start'><li className='k'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Machine Learning</li></Link>
                      <Link to='/CS' className='program_popup_link d-flex justify-content-start'><li className='py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Cyber Security</li></Link>
                      </ul>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <ul>
                      <Link to='/WD' className='program_popup_link d-flex justify-content-start'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Web Development </li></Link>
                      <Link to='/CC' className='program_popup_link d-flex justify-content-start'><li className=' py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Cloud Computing</li></Link>
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <div className='text-center pt-3'>
                <Link to='/Traineeship-program'><button  className="text-white shadow-sm fs-6 px-5 py-2 Navbar_button">View More</button></Link>
                </div>
            </div>
            <div className='col-md-6 border-start border-dark'>
                <div className='Program_pop_up_text'>
                <h5 className='text-center'>Advance Program</h5>
                <p className='px-5 pt-2 text-center'>Unleash your potential through our comprehensive programs, designed to propel your expertise to new heights </p>
                <div className='container'>
                  <div className='row'>
                  <div className='col-md-6'>
                      <div className=''>
                      <ul className=''>
                      <Link to='/CCD' className='program_popup_link d-flex justify-content-start'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />DSA With C, C++</li></Link>
                      <Link to='/MS' className='program_popup_link d-flex justify-content-start'><li className='py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Mern stack</li></Link>
                      </ul>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <ul>
                      <Link to='/PY' className='program_popup_link d-flex justify-content-start'><li className=''><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Python</li></Link>
                      <Link to='/java' className='program_popup_link d-flex justify-content-start'><li className=' py-3'><AiOutlineArrowRight className='mx-2'  size="20px" color="#7A7A7A" />Java</li></Link>
                      </ul>
                    </div>
                  </div>
                </div>
                </div>
                <div className='text-center pt-3'>
                <Link to='/Advance-program'><button  className="text-white shadow-sm fs-6 px-5 py-2 Navbar_button">View More</button></Link>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Program_Popup_Content
